// extracted by mini-css-extract-plugin
export var divider = "_dm-7";
export var itemsToggle = "_dm-8";
export var mergeModal = "_dm-1";
export var optionCard = "_dm-4";
export var radioGroup = "_dm-6";
export var radioOption = "_dm-0";
export var selected = "_dm-5";
export var shipmentOptions = "_dm-2";
export var tableOptions = "_dm-3";